import styled from 'styled-components'

const NestedFieldContainer = styled.div`
  /* ${(props: any) => props.marginLeft && `margin-left: ${props.marginLeft}`}; */
  margin-top: 8px;
  padding: 8px;
`

export default NestedFieldContainer as any
